import * as React from "react";
import { WithStyles, Theme, createStyles, withStyles } from "@material-ui/core";

import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import ErrorIcon from "@material-ui/icons/Error";

interface ConnectedPanicOverlayProps extends WithStyles<typeof styles> {}

type Props = ConnectedPanicOverlayProps;

export class PanicOverlay extends React.PureComponent<Props, {}> {
	handleOKClick = () => {
		if (
			window.location.href !== window.location.origin &&
			window.location.href.slice(0, -1) !== window.location.origin
		) {
			window.location.replace("/");
		} else {
			window.location.reload();
		}
	};

	render() {
		const { classes } = this.props;

		return (
			<div className={classes.root}>
				<Paper className={classes.paper}>
					<ErrorIcon className={classes.icon} />
					<div className={classes.content}>
						<Typography variant="title">
							Kritischer Fehler
						</Typography>
						<Typography
							className={classes.paragraph}
							variant="body1"
						>
							Es ist ein Fehler aufgetreten!
							<br />
							Bitte versuchen Sie es erneut.
						</Typography>
						<Typography
							className={classes.paragraph}
							variant="body1"
						>
							Sollte dieser Fehler wieder auftreten, wenden Sie
							sich bitte an Ihren Administrator.
						</Typography>
					</div>
					<Button
						className="ok"
						variant="raised"
						color="primary"
						onClick={this.handleOKClick}
					>
						OK
					</Button>
				</Paper>
			</div>
		);
	}
}

const styles = (theme: Theme) =>
	createStyles({
		root: {
			position: "fixed",
			top: 0,
			left: 0,
			width: "100%",
			height: "100%",
			zIndex: 57,
			backgroundColor: "rgba(0,0,0,0.5)",
			display: "flex",
			alignItems: "center",
			justifyContent: "center"
		},
		paper: {
			padding: theme.spacing.unit * 2,
			textAlign: "center"
		},
		content: {
			maxWidth: 300,
			marginTop: 15,
			marginBottom: 25
		},
		icon: {
			color: theme.palette.error.main,
			width: 48,
			height: 48
		},
		paragraph: {
			marginTop: 15
		}
	});

export const ConnectedPanicOverlay = withStyles(styles)(PanicOverlay);
